module.exports = __webpack_public_path__ + "img/percent-line.cfa149be.svg";